// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__4DO3r","label":"SetPasswdForm_label__cEEgJ"};